import React, { useState, useEffect } from 'react';
import { ListLayout } from '../../containers/Layout';
import { TableRow, TableCell, Button, TableHead, TableBody, Box, IconButton, Tab, Tabs, Tooltip, MenuItem, Menu, ListItemIcon, ListItemText } from '@material-ui/core';
import { AddRounded, CloseRounded, CheckBoxRounded, CloudDownloadRounded, EditRounded, MoreVertRounded, SendRounded } from '@material-ui/icons';
import { isEmpty, size } from 'lodash';
import { toast } from 'react-toastify';
import { useFetchTransfers } from '../../../../../../../../jsx/hooks/getTransfers';
import StockExtractButton from '../../StockExtractButton';
import DeleteDialogConfirm from '../../../../../commonModules/interface/DeleteDialogConfirm';
import { InputSelectMagasin } from '../../../../../commonModules/interface/form-input-inline';
import TableFooterPagination from '../../../../../commonModules/interface/TableFooterPagination';
import { useSelector } from 'react-redux';

const ListTransferResa = (props) => {
    const [view, setView] = useState("resa");
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [toDelete, setToDelete] = useState({
        id: ""
    });
    const [search, setSearch] = useState("");
    const [received, setReceived] = useState("ALL");
    const [filteredList, setFilteredList] = useState([]);
    const [resaList, setResaList] = useState(<div></div>);
    const [reload, setReload] = useState(false);
    const [selectShop, setSelectShop] = useState("");
    const [selectShopDisplay, setSelectShopDisplay] = useState({
        value: "",
        label: "Tous les Magasins",
    });
    const fetchTransfers = useFetchTransfers("reservation_demande");
    const STATE = useSelector((state) => state.inventory.requestState); 
    const RESA_DEMANDS = useSelector((state) => state.inventory.resaDemands); 
    const SHOPS = useSelector((state) => state.inventory.shops); 

    useEffect(() => {
        console.log('MOUNTING ListTransferResas ');
        if (isEmpty(RESA_DEMANDS)){
            fetchTransfers();
        }else{
            filterList("", "ALL"); 
        }
    }, []);
    useEffect(() => {
        console.log('RESA_DEMANDS a changé :', RESA_DEMANDS);
        filterList("", "ALL");
    }, [RESA_DEMANDS]);

    useEffect(() => {
        console.log('filteredList a changé :');
        const listResa = createList();
        setResaList(listResa);
    }, [filteredList]);

    const statusContent = (status) =>{
        let statusPrintable = ""
        switch (status) {
            case "waiting":
                statusPrintable = "En attente traitement"
                break;
            case "partly":
                statusPrintable = "Partiellement prete"
                break;
            case "partly":
                statusPrintable = "Commande prête"
                break;
            case "ready":
                statusPrintable = "Commande à récupérer"
                break;
            case "dispatch":
                statusPrintable = "Retirée"
                break;
            default:
                statusPrintable = "unknown"
                break;
        }
        return  statusPrintable
    }
    const findUserName = (user_id) =>{
        const { USERS } = props
        if (user_id===""){
            return ""
        }
        if (USERS){
            let userInfo = Object.values(USERS).filter( user => {if (user.userID===user_id){return true} })
            if(userInfo.length === 1){
                return userInfo[0].name
            }
        }
        return ""
    }
    const createList = () => {
        const { currentPage, rowsPerPage } = props;

        return filteredList.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map((transfer) => {
            let shop = SHOPS[transfer.shop_id];
            return (
                <TableRow key={transfer.id}>
                <TableCell>{new Date(transfer.creation_date).toLocaleString('fr-FR')}</TableCell>
                <TableCell>{new Date(transfer.usage_date).toLocaleDateString('fr-FR')}</TableCell>
                <TableCell>
                    <a href="#" onClick={() => props.handleSingleShop(shop)}>
                    {shop.name}
                    </a>
                </TableCell>
                <TableCell>
                    {transfer.comments}
                </TableCell>
                <TableCell>
                    {statusContent(transfer.resa_status)}
                </TableCell>
                <TableCell>
                    {findUserName(transfer.user_id)}
                </TableCell>
                <TableCell>
                    <IconButton color="secondary" onClick={() => props.handleSingleResa(transfer, shop)}>
                        <AddRounded />
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Tooltip placement="top" title="Supprimer">
                        <IconButton onClick={() => setToDelete(transfer, setDeletePopUp(true))}>
                            <CloseRounded color="error" /> 
                        </IconButton>
                    </Tooltip>
                </TableCell>
                </TableRow>
            );
        });
    };

    const createShopList = () => {
        const list = [{ value: "", label: "Tous les Magasins" }];
        if (SHOPS) {
            Object.values(SHOPS).map((shop) => {
                list.push({ value: shop.id, label: shop.name });
            });
        }
        return list;
    };

    const shopFilter = (selected) => {
        //const { RESA_DEMANDS } = props;
        console.log("[DEBUG],shopFilter ",RESA_DEMANDS)
        if (typeof RESA_DEMANDS === "undefined"){
            toast.error("Aucune resa disponible")
            return
        }
        let filteredShop = Object.values(RESA_DEMANDS).filter((transfer) => transfer.shop_id === selected);

        console.log({ filteredShop });

        return filteredShop;
    };

    const filterList = (selectedShop = selectShop, searchReceived = received, searchView = view) => {
        console.log("filterList",{ selectedShop, searchView });
        let list = Object.values(RESA_DEMANDS);
        if (isEmpty(list)){
            //toast.error("No resa available")
            return
        }
        let filteredList = selectedShop ? shopFilter(selectedShop) : list;

        // if (typeof searchReceived == "boolean") {
        //     filteredList = filteredList.filter((item) => item.received == searchReceived);
        // }
        setFilteredList(filteredList);
        setReload(!reload);
        setView(searchView);
    };

    const deleteResa = async (comments) => {
        let data = {
            op_id: toDelete.id,
            comments,
        };
        try{
            const resp  =await props.deleteResa(data);
            toast.success("Demande reservation supprimée avec succès");
            setDeletePopUp(false);
            setToDelete({ id: "" });
        }catch(err){
            console.log("[ERROR] delete transfer", {err});
            toast.error("[ERROR],"+err.message);
        }

    };
    
  let shops = createShopList();

    return (
        <Box>
            {deletePopUp && (
                <DeleteDialogConfirm
                    title={"la reservation n°" + toDelete.id}
                    handleSubmit={deleteResa}
                    block={true}
                    close={() => setDeletePopUp(false)}
                />
            )}
           
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
                <InputSelectMagasin
                    options={shops}
                    value={selectShopDisplay}
                    label="Sélectionner un Magasin"
                    onChange={(option) => {
                        setSelectShopDisplay(option);
                        setSelectShop(option.value);
                        filterList(option.value, undefined);
                    }}
                    maxWidth
                />
            </Box>
            
            <ListLayout>
                <TableHead>
                    <TableRow>
                        <TableCell>Date de création</TableCell>
                        <TableCell>Date souhaitée</TableCell>
                        <TableCell>Shop</TableCell>
                        <TableCell>Commentaire</TableCell> 
                        <TableCell>Etat</TableCell> 
                        <TableCell>Demandeur</TableCell> 
                        <TableCell>Détails</TableCell>
                        <TableCell>Options</TableCell>
                    </TableRow>
                </TableHead>
                    <TableBody>
                        {filteredList.length > 0 && resaList}
                        {filteredList.length === 0 && (
                        <TableRow>
                            <TableCell colSpan={6}>
                            <div className="text-center">
                                Cliquez sur{" "}
                                <Button
                                    color="primary"
                                    className="text-right"
                                >
                                Nouveau
                                </Button>{" "}
                                pour entrer une nouvelle Demande de reservation
                            </div>
                            </TableCell>
                        </TableRow>
                        )}
                    </TableBody>
                
                {filteredList.length > 0 && (
                    <TableFooterPagination colSpan={6} items={filteredList} onChangePage={props.onChangePage} initialPage={props.currentPage || 0} />
                )}
            </ListLayout>
        </Box>
    );
};

export default ListTransferResa;
